module.exports = __webpack_public_path__ + "media/images/voice-logo-9153a70f990008e548250f236f5d7239.png";